
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IOrderForm, IXdocPlanning, IFileList } from '@/types/placeOrderTypes'
import { IServiceMap } from '@/business/BusinessFormData'
import { getStyleConfig } from '@/api/Allservices'
import FbdStyleLibrary from './FbdStyleLibrary.vue'
import StyleDemoFbd from '../../StyleDemoFbd/index.vue'

@Component({
  components: {
    FbdStyleLibrary,
    StyleDemoFbd
  },
})
export default class XdocProjectPlanForWord extends Vue {
  @Prop() form!: IOrderForm
  @Prop() checkForm!: Function
  @Prop() formInfo!: IServiceMap
  fbdVisible = false
  fbdConfigVisible = false
  fbdConfigEditVisible = false

  projects: IXdocPlanning[] = []
  currProject: IXdocPlanning = { name: '', config: { fbd_type: 1, delivery: 0 } }
  fileList: IFileList[] = []
  CheckAll = false

  get xdocFileList() {
    const arr = this.fileList.map(item => {
      return {
        id: item.id,
        fileList: [item.file].map(item => {
          return { name: item!.name, select: false }
        }),
        fileName: item.file?.name,
      }
    })
    return arr
  }

  get xdocProjects() {
    return this.projects.map(item => {
      item.origin_files = (item.origin_files || []).map(item => {
        item = { ...item, selected: false }
        return item
      })
      item.compare_pdf = (item.compare_pdf || []).map(item => {
        item = { ...item, selected: false }
        return item
      })
      return item
    })
  }

  @Watch('form', { deep: true })
  async formChange() {
    await this.init()
  }

  async mounted() {
    await this.init()
    this.$nextTick(() => {
      if ((this as any).$refs.styleButton && this.$route.query.reOpen) {
        ;(this as any).$refs.styleButton[0].$el.click()
      }
    })
  }

  init() {
    if (this.form.service_content == 24) {
      this.fileList = this.form.material.oss_pdf_files!.map(item => {
        return {
          file: { name: item.name },
          status: 'upload-success',
        }
      })
    } else {
      this.fileList = this.form.material.oss_images!.map(item => {
        return {
          file: { name: item.name },
          status: 'upload-success',
        }
      })
    }

    if (this.form && this.form.xdoc_planning) {
      this.projects = this.form.xdoc_planning
      this.currProject = this.projects[0]
    }

    ;(this as any).$updateQuery({
      fbd_config_visible: '0',
    })
  }

  cancleDialog() {
    this.fbdVisible = false
    ;(this as any).$updateQuery({
      fbd_config_visible: '0',
    })

    this.xdocFileList.forEach(item =>
      item.fileList.forEach((item: { name: string; select: boolean }) => {
        item.select = false
      }),
    )
    this.$forceUpdate()
  }

  getOriginFilesName(file: string) {
    const name = file.split('/')[file.split('/').length - 1]
    const nameArr = name.split('.')
    nameArr[nameArr.length - 1] = nameArr[nameArr.length - 1].toLowerCase()
    return nameArr.join('.')
  }

  handleCheckAllChange(val: boolean) {
    this.xdocFileList.map(item => {
      item.fileList.map(word => {
        this.handleFbdsChange(val, item, word)
      })
    })
    this.CheckAll = val
  }

  handleFbdsChange(
    val: boolean,
    item: { fileList: { name: string; select: boolean }[] },
    word: { name: string; select: boolean },
  ) {
    this.$set(word, 'select', val)
    // 由于计算属性的引用不会更新，所以需要强制刷新一次视图
    this.$forceUpdate()
    const arr: string[] = item.fileList
      .filter(item => item.select)
      .map(item => {
        return this.getOriginFilesName(item.name)
      })

    function isRepeat(arr: string[]) {
      const hash: any = {}
      for (const i in arr) {
        if (hash[arr[i]]) return true
        hash[arr[i]] = true
      }
      return false
    }

    if (isRepeat(arr)) {
      return this.$message.error('请勿选择同名文件')
    } else {
      this.$set(item, 'checkFbdList', arr)
    }
  }

  projectFbdChange() {
    let textArr = this.currProject.origin_files!.filter(item => item.type === 1)
    let answerArr = this.currProject.origin_files!.filter(item => item.type === 0)
    const origin_files: { index: number; type: number; name: string; fbd_zip_name?: string }[] = []
    for (const item of this.xdocFileList) {
      item.fileList.forEach((fbd: { name: string; select: boolean }) => {
        if (fbd.select) {
          origin_files.push({
            index: origin_files.length,
            type: 1,
            name: this.getOriginFilesName(fbd.name).split('.fbd').join(''),
          })
        }
      })
    }
    textArr = origin_files
    this.$set(this.currProject, 'origin_files', answerArr.concat(textArr))
    this.cancleDialog()
  }

  initSelectFbd() {
    this.currProject.origin_files!.forEach(item => {
      const xdoc = this.xdocFileList.find(xdoc => item.name === xdoc.fileName)
      const fbd = xdoc!.fileList.find(
        (fbd: { name: string; select: boolean }) => fbd.name.includes(item.name) && item.type === 1,
      )
      if (fbd) {
        this.$set(fbd, 'select', true)
      }
    })
  }

  handleClose(pId: number) {
    this.$confirm('是否删除此计划?', '提示', {
      type: 'warning',
    })
      .then(() => {
        this.projects.splice(pId, 1)
      })
      .catch(e => e)
  }

  async openStyleLibrary(project: IXdocPlanning) {
    ;(this as any).$updateQuery({
      fbd_config_visible: '1',
    })
    this.currProject = project
    // 保存一下表单数据
    this.$emit('saveForm')
  }

  async handleFbdConfigSave(style_id: number) {
    const config = await getStyleConfig({
      style_id,
    })
    this.$set(this.currProject.config, 'style_config_data', config.config)

    let type = this.form.service_content == 24 ? 'pdf_type' : 'img_type'
    if (config.type) {
      this.$set(this.currProject.config, type, config.type)
    } else {
      this.$set(this.currProject.config, type, 'paper')
    }

    this.$set(this.currProject.config, 'style_config_name', config.name)
    this.$set(this.currProject.config, 'style_id', config._id)
    ;(this as any).$updateQuery({
      fbd_config_visible: '0',
    })

    this.$emit('selectedLibrary')
  }

  handleFbdConfigEditSave(config: any) {
    this.$set(this.currProject.config, 'style_config_data', config.config)
    this.$set(this.currProject.config, 'style_config_name', config.name)
    this.fbdConfigEditVisible = false
  }

  @Watch('$route.query.fbd_config_visible', { deep: true, immediate: true })
  async fbdConfigVisibleChange() {
    this.fbdConfigVisible = this.$route.query.fbd_config_visible === '1'
  }
}
